<template>
  <button
      v-if="show"
      class="trash-btn btn btn-warning mt-0 float-left"
      @click="deleteItem"
  >
    <font-awesome-icon icon="trash" />
  </button>
</template>
<script>
import {actionTypes as formSettingsActions} from '@/store/modules/formSettings'

export default {
  props: ['id', 'show'],
  methods: {
    deleteItem() {
      let payload = this.id
      this.$confirm('Вы уверены что хотите удалить?',
      "Подтверждение удаления",
        {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        }
      ).then(() => {
        this.$store.dispatch(formSettingsActions.deleteItem, payload)
            .then(() => this.$message({message: 'Пункт удалён', type: 'success'}))
      })
    },
  }
}
</script>